import type { LBNodeData } from '@/proto/logiblocks/logiblocks';
import { TRIGGER_ICON_COLOR } from '../../styles';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { ManualTriggerIcon } from '@/assets/icons/icons';
import { ManualExecutionTriggerCustomization } from './ManualExecutionTriggerCustomization';
import { manualTriggerList } from '@/common/static_data';
import { buildNodeData } from '../../nodeDataUtils';

//TODO : add output variables and validations errors

export const manualExecutionTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'manual_execution_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Manual execution',

  hasInput: false,

  getIcon: (size: number) => (
    <ManualTriggerIcon color={TRIGGER_ICON_COLOR} width={size} height={size} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const d = data.manual_execution_trigger;
    if (!d) return '';

    const externalTrigger = manualTriggerList.find(
      (x) => x.value === d.external_trigger
    );

    return externalTrigger ? externalTrigger.label : '';
  },

  CustomizationComponent: ManualExecutionTriggerCustomization,

  createDefaultNodeData: () =>
    buildNodeData('manual_execution_trigger', {
      external_trigger: '',
      execution_keyword: '',
    }),
};
